import Vue from 'vue'
import axios from 'axios';

// login troca de senha 
Vue.prototype.$novaSenha = async (senha,uuid) => {
  try {
    let res = await axios.post('login/novasenha/'+uuid,{
      senha:senha
    });
    return res.data;
  } catch (e) {
    throw e;
  }
}

// login ativar conta
Vue.prototype.$ativarConta = async (token) => {
  try {
    let res = await axios.post('conta/ativar/'+token,{
    });
    return res.data;
  } catch (e) {
    throw e;
  }
}

